import type {Control, FieldPath, FieldValues} from 'react-hook-form';
import type {TextFieldProps as BaseProps} from '@mui/material/TextField/TextField';
import type {ChangeEvent} from 'react';
import {validateIIN} from "@/global/helpers/validators";
import {TextFieldForm} from "@/global/components/FormInputs/TextFieldForm";

type ControlledFieldProps<T extends FieldValues> = {
    control: Control<T>;
    name: FieldPath<T>;
    resetErrors: (name: FieldPath<T>) => void;
    label?: string;
    formSx?: BaseProps['sx'];
    displayErrors?: boolean;
} & BaseProps;

export function IinInput<T extends FieldValues>({
                                                    control,
                                                    name,
                                                    resetErrors,
                                                    displayErrors,
                                                    ...props
                                                }: ControlledFieldProps<T>) {
    const validate = (eventValue: string | undefined = undefined) => {
        const value = eventValue ?? control._formValues[name];
        const parsedIIN = validateIIN(value);
        if (!parsedIIN) {
            control.setError(name, { message: 'Неверный ИИН' });
        }
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = (event.target.value || '')
            .replace(/[^0-9]/gim, '')
            .slice(0, 12);
        event.target.value = value;
        resetErrors(name);
        if (displayErrors) {
            validate(value);
        }
    };

    return (
        <TextFieldForm
            formSx={{
                '& .MuiTextField-root': {
                    //marginTop: 2
                }
            }}
            control={control}
            name={name}
            onChange={handleChange}
            onBlur={() => validate()}
            {...props}
        />
    );
}
